import { Chart } from "react-google-charts";
import { Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    // Remove Paper styling since it's now inside the main Paper
  },
  chartContainer: {
    minHeight: "400px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loadingText: {
    color: theme.palette.text.secondary,
  },
}));

const GeoChart = ({ data, title = "Reproducciones alrededor del mundo" }) => {
  const classes = useStyles();

  if (!data?.length) {
    return (
      <div className={classes.root}>
        <Typography variant="h5" gutterBottom>
          {title}
        </Typography>
        <Box className={classes.chartContainer}>
          <Typography variant="body2" className={classes.loadingText}>
            No hay datos geográficos disponibles
          </Typography>
        </Box>
      </div>
    );
  }

  const options = {
    colorAxis: {
      colors: ["#e8f5e8", "#4caf50", "#2e7d32"], // Light to dark green gradient
    },
    backgroundColor: "transparent",
    datalessRegionColor: "#f5f5f5",
    defaultColor: "#f5f5f5",
    tooltip: {
      textStyle: { fontSize: 12 },
    },
    legend: {
      textStyle: { fontSize: 12 },
    },
  };

  return (
    <div className={classes.root}>
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>

      <div className={classes.chartContainer}>
        <Chart
          chartType="GeoChart"
          width="100%"
          height="400px"
          data={data}
          options={options}
          loader={
            <Typography variant="body2" className={classes.loadingText}>
              Cargando mapa...
            </Typography>
          }
        />
      </div>
    </div>
  );
};
export default GeoChart;
